import { Route } from '@angular/router';

import { TimeSeriesChartsResolver } from './time-series-charts.resolvers';
import { TimeSeriesChartsComponent } from './time-series-charts.component';
import { TimeSeriesChartsAnalyticsComponent } from './analytics/analytics.component';
import { ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';

export const timeSeriesChartsRoutes: Route[] = [
  {
    path: '',
    component: TimeSeriesChartsComponent,
    resolve: {},
    children: [
      {
        path: '',
        component: TimeSeriesChartsAnalyticsComponent,
        resolve: {
          timeSeriesCharts: TimeSeriesChartsResolver,
          fieldDefs: ProjectsFieldDefsResolver,
        },
      },
    ],
  },
];
